export const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const keyOfMonth = 'yyyy-MM';
export const keyOfDay = 'yyyy-MM-dd';
